import { render } from "./BackgroundLogo.vue?vue&type=template&id=743df02a"
const script = {}

import "./BackgroundLogo.vue?vue&type=style&index=0&id=743df02a&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__